import React from 'react'
import PropTypes from 'prop-types'
import { ReactSVG } from 'react-svg'
import { Wrapper } from './IconStyle'

const Icon = ({ icon, ...props }) => {
  const [isLoading, setIsLoading] = React.useState(false)
  const [svgUrl, setSvgUrl] = React.useState(null)

  React.useEffect(() => {
    setIsLoading(true)
    const importIcon = async () => {
      try {
        const iconComponent = await import(`./icons/${icon}.svg`)
        setSvgUrl(iconComponent.default)
      } catch (err) {
        // Your own error handling logic, throwing error for the sake of
        // simplicity
        throw err
      } finally {
        setIsLoading(false)
      }
    }
    importIcon()
  }, [icon])

  if (!isLoading && svgUrl) {
    return (
      <Wrapper {...props}>
        <ReactSVG
          beforeInjection={svg => {
            svg.setAttribute('style', 'width: 100%; height: 100%')
          }}
          src={svgUrl}
        />
      </Wrapper>
    )
  }

  return null
}

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
  size: PropTypes.number,
}

export default Icon
